/* unplugin-vue-components disabled */
const __default__ = {
  mixins: [ModelValue(String)],
  props: {
    bordered: {
      type: Boolean, default: false
    },
    tabs: {
      type: Array, default: () => ([])
    },
    tabPosition: {
      type: String, default: 'top'
    }
  },
  computed: {
    c_tabs() {
      return this.tabs.map(t => typeof t === 'string' ? {title: $utils.str.capitalize(t), value: t} : t)
    },
    border_color() {
      return this.bordered ? 'var(--gray-200)' : 'transparent'
    }
  },
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "ed220ea4-border_color": (_ctx.border_color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__